import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import IndividualContact from "../../model/contact/IndividualContact";
import {store} from "../../navigation/ReduxProvider";

/**
 * Gets individual contact.
 * @param {string} contactId Contact identifier.
 * @param {RootState} state Root state.
 * @returns {Option<IndividualContact>} Individual contact.
 */
export function getIndividualContact(contactId: string, state: RootState = store.getState()): Option<IndividualContact> {
	let contact = state.contact.individualContactMap[contactId];
	return option(contact);
}